import { JsonRpcProvider } from '@ethersproject/providers';
import { UPMessage, UPResponse, UPAuthMessage } from '@unipasswallet/popup-types';
import { encodeTypedDataDigest } from '@unipasswallet/popup-utils';
import { Contract } from 'ethers';
import { toUtf8Bytes, keccak256, concat, hexlify } from 'ethers/lib/utils';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var UP_DOMAIN = 'wallet.unipass.id';
var config = {
  upDomain: UP_DOMAIN,
  upConnectUrl: "https://" + UP_DOMAIN + "/connect",
  upLogoutUrl: "https://" + UP_DOMAIN + "/logout",
  upSignMessageUrl: "https://" + UP_DOMAIN + "/sign-message",
  upTransactionUrl: "https://" + UP_DOMAIN + "/send-transaction",
  upLoadingUrl: "https://" + UP_DOMAIN + "/connect/loading"
};
var config$1 = (function (option) {
  var domain = option.domain,
    protocol = option.protocol;
  domain = domain || UP_DOMAIN;
  protocol = protocol || 'https';
  config = {
    upDomain: domain,
    upConnectUrl: protocol + "://" + domain + "/connect",
    upLogoutUrl: protocol + "://" + domain + "/logout",
    upSignMessageUrl: protocol + "://" + domain + "/sign-message",
    upTransactionUrl: protocol + "://" + domain + "/send-transaction",
    upLoadingUrl: protocol + "://" + domain + "/connect/loading"
  };
  return config;
});
var getConfig = function getConfig() {
  return config;
};
var TEST_WALLET_URL = {
  protocol: 'https',
  domain: 'testnet.wallet.unipass.id'
};
var MAIN_WALLET_URL = {
  protocol: 'https',
  domain: 'wallet.unipass.id'
};
var NODE_RPC_LIST = {
  mainnet: {
    eth: 'https://node.wallet.unipass.id/eth-mainnet',
    polygon: 'https://node.wallet.unipass.id/polygon-mainnet',
    bsc: 'https://node.wallet.unipass.id/bsc-mainnet',
    rangers: 'https://node.wallet.unipass.id/rangers-mainnet',
    scroll: 'https://node.wallet.unipass.id/scroll-mainnet',
    arbitrum: 'https://node.wallet.unipass.id/arbitrum-mainnet',
    avalanche: 'https://node.wallet.unipass.id/avalanche-mainnet',
    kcc: 'https://node.wallet.unipass.id/kcc-mainnet',
    platon: 'https://node.wallet.unipass.id/platon-mainnet',
    okc: 'https://node.wallet.unipass.id/okc-mainnet'
  },
  testnet: {
    eth: 'https://node.wallet.unipass.id/eth-goerli',
    polygon: 'https://node.wallet.unipass.id/polygon-mumbai',
    bsc: 'https://node.wallet.unipass.id/bsc-testnet',
    rangers: 'https://node.wallet.unipass.id/rangers-robin',
    scroll: 'https://node.wallet.unipass.id/scroll-testnet',
    arbitrum: 'https://node.wallet.unipass.id/arbitrum-testnet',
    avalanche: 'https://node.wallet.unipass.id/avalanche-testnet',
    kcc: 'https://node.wallet.unipass.id/kcc-testnet',
    platon: 'https://node.wallet.unipass.id/platon-testnet',
    okc: 'https://node.wallet.unipass.id/okc-testnet'
  }
};
var getDefaultConfigOption = function getDefaultConfigOption(env, chainType) {
  return {
    env: env,
    nodeRPC: env === 'prod' ? NODE_RPC_LIST.mainnet[chainType] : NODE_RPC_LIST.testnet[chainType],
    chainType: chainType,
    walletUrl: env === 'prod' ? MAIN_WALLET_URL : TEST_WALLET_URL
  };
};
var getAppSettings = function getAppSettings(chainType, settings) {
  var chain = (settings == null ? void 0 : settings.chain) || chainType;
  var appName = (settings == null ? void 0 : settings.appName) || 'MyDemo';
  var _settings = settings || {};
  return _extends({}, _settings, {
    chain: chain,
    appName: appName
  });
};
var getAuthProviderUrl = function getAuthProviderUrl(env) {
  return env === 'prod' ? NODE_RPC_LIST.mainnet.polygon : NODE_RPC_LIST.testnet.polygon;
};

var useStorage = function useStorage(storageType) {
  var _storage;
  if (storageType === 'localStorage') {
    _storage = window.localStorage || localStorage;
  } else {
    _storage = window.sessionStorage || sessionStorage;
  }
  var get = function get(key) {
    return _storage.getItem(key) || '';
  };
  var set = function set(key, value) {
    return _storage.setItem(key, value || '');
  };
  var remove = function remove(key) {
    return _storage.removeItem(key);
  };
  return {
    get: get,
    set: set,
    remove: remove
  };
};

var connect = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, options) {
    var sessionAccount, account;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sessionAccount = useStorage(config.storageType).get(UPA_SESSION_KEY);
          _context.t0 = sessionAccount && JSON.parse(sessionAccount);
          if (_context.t0) {
            _context.next = 6;
            break;
          }
          _context.next = 5;
          return getAccount(config, options);
        case 5:
          _context.t0 = _context.sent;
        case 6:
          account = _context.t0;
          return _context.abrupt("return", account);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function connect(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getLocalAccount = function getLocalAccount(storageType) {
  var sessionAccount = useStorage(storageType).get(UPA_SESSION_KEY);
  if (sessionAccount) {
    return JSON.parse(sessionAccount);
  } else {
    return undefined;
  }
};
var disconnect = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(deep) {
    var message;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!deep) {
            _context2.next = 4;
            break;
          }
          message = new UPMessage('UP_LOGOUT');
          _context2.next = 4;
          return execPop(message);
        case 4:
          useStorage('localStorage').remove(UPA_SESSION_KEY);
          useStorage('sessionStorage').remove(UPA_SESSION_KEY);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function disconnect(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var getAccount = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(config, options) {
    var payload, message, account;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          payload = options ? JSON.stringify(options) : '';
          message = new UPMessage('UP_LOGIN', payload, config.appSettings);
          _context3.next = 5;
          return execPop(message, options == null ? void 0 : options.connectType, options == null ? void 0 : options.forceLogin, options == null ? void 0 : options.eventListener);
        case 5:
          account = _context3.sent;
          if (account && account.address) {
            useStorage(config.storageType).set(UPA_SESSION_KEY, JSON.stringify(account));
          }
          return _context3.abrupt("return", account);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          throw new Error('Account Not Available');
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return function getAccount(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var POP = 'UP_WALLET_POP';
var popup = null;
var previousUrl = null;
function popupWindow(url, windowName, win) {
  var w = 462;
  var h = 810;
  var top = (win.screen.availHeight - 30 - h) * 0.5;
  var left = (win.screen.availWidth - 10 - w) * 0.8;
  var config = "innerWidth=" + w + ",width=" + w + ",innerHeight=" + h + ",height=" + h + ",top=" + top + ",left=" + left + ",toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,";
  return win.open(url, windowName, config);
}
function renderPop(_x, _x2, _x3) {
  return _renderPop.apply(this, arguments);
}
function _renderPop() {
  _renderPop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(src, onResponse, appSettings) {
    var _popup;
    var timer, unmount;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(popup == null || (_popup = popup) != null && _popup.closed)) {
            _context.next = 8;
            break;
          }
          popup = popupWindow(src, POP, window);
          if (!(popup == null)) {
            _context.next = 6;
            break;
          }
          _context.next = 5;
          return createBlockedTip(src, onResponse, appSettings);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.next = 9;
          break;
        case 8:
          if (previousUrl !== src) {
            popup.location.replace(src);
            popup.focus();
          } else {
            popup.focus();
          }
        case 9:
          // previousUrl = src;
          timer = setInterval(function () {
            if (popup && popup.closed) {
              var event = {
                data: new UPMessage('UP_RESPONSE', JSON.stringify(new UPResponse('DECLINE', 'user reject connection')))
              };
              onResponse(event, {
                close: function close() {},
                send: function send() {}
              });
              clearInterval(timer);
            }
          }, 1000);
          unmount = function unmount() {
            if (popup && !popup.closed) {
              popup.close();
            }
            popup = null;
          };
          return _context.abrupt("return", {
            popup: popup,
            unmount: unmount
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderPop.apply(this, arguments);
}
function createBlockedTip(_x4, _x5, _x6) {
  return _createBlockedTip.apply(this, arguments);
}
function _createBlockedTip() {
  _createBlockedTip = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(src, onResponse, appSettings) {
    var divHTML, innerHtml, up_button;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          divHTML = document.createElement('div');
          innerHtml = "\n  <div\n  class=\"up_notification\"\n  style=\"\n    position: fixed;\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n    top: 26px;\n    right: 26px;\n    width: 340px;\n    height: 96px;\n    z-index: 100001;\n    background-color: #362866;\n    box-sizing: border-box;\n    border: 2px solid #ffffff;\n    border-radius: 8px;\n    padding: 16px 20px;\n  \"\n>\n  <div class=\"up_notification_left\" style=\"color: white\">\n    <div\n      class=\"up_notification_title\"\n      style=\"\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        margin-bottom: 8px;\n      \"\n    >\n      Request Pop-up\n    </div>\n    <div\n      class=\"up_notification_tip\"\n      style=\"\n        font-weight: 450;\n        font-size: 12px;\n        line-height: 20px;\n        color: rgba(255, 255, 255, 0.8);\n      \"\n    >\n      Click Approve to complete creating or using wallet\n    </div>\n  </div>\n  <div\n    class=\"up_notification_right\"\n    style=\"\n      width: 90px;\n      height: 35px;\n      font-size: 12px;\n      text-align: center;\n      background: linear-gradient(270deg, #997afb 0%, #7a55f8 63.6%);\n      border-radius: 6px;\n      line-height: 35px;\n      color: white;\n      margin-left: 20px;\n      cursor: pointer;\n    \"\n  >\n    Approve\n  </div>\n</div>\n    ";
          divHTML.innerHTML = innerHtml;
          document.body.appendChild(divHTML);
          up_button = document.querySelector('.up_notification_right');
          return _context2.abrupt("return", new Promise(function (resolve) {
            up_button == null ? void 0 : up_button.addEventListener('click', function () {
              document.body.removeChild(divHTML);
              resolve(renderPop(src, onResponse, appSettings));
            }, false);
          }));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createBlockedTip.apply(this, arguments);
}

var noop = function noop() {};
// const GOOGLE_OAUTH_CONFIG = {
//   clientID:
//     '1076249686642-g0d42524fhdirjeho0t6n3cjd7pulmns.apps.googleusercontent.com',
// };
// const genGoogleOAuthUrl = () => {
//   const redirectURI = encodeURIComponent(
//     serviceEndPoint('UP_LOGIN') + '/loading'
//   );
//   return `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?redirect_uri=${redirectURI}&prompt=consent&response_type=id_token%20token&client_id=${GOOGLE_OAUTH_CONFIG.clientID}&scope=openid%20email&state=af0ifjsldkj&nonce=n-0S6_WzA2Mj&flowName=GeneralOAuthFlow`;
// };
function serviceEndPoint(type, connectType, forceLogin) {
  if (type === 'UP_LOGIN') {
    if (connectType === 'google') {
      return getConfig().upConnectUrl + ("?connectType=google&forceLogin=" + (forceLogin ? '1' : '0'));
    }
    if (connectType === 'email') {
      return getConfig().upConnectUrl + ("?connectType=email&forceLogin=" + (forceLogin ? '1' : '0'));
    }
    return getConfig().upConnectUrl + ("?forceLogin=" + (forceLogin ? '1' : '0'));
  } else if (type === 'UP_LOGOUT') {
    return getConfig().upLogoutUrl;
  } else if (type === 'UP_SIGN_MESSAGE') {
    return getConfig().upSignMessageUrl;
  } else if (type === 'UP_TRANSACTION') {
    return getConfig().upTransactionUrl;
  } else if (type === 'UP_READY') {
    return getConfig().upLoadingUrl;
  }
  throw new Error("unsupport type " + type);
}
function pop(_x, _x2, _x3, _x4) {
  return _pop.apply(this, arguments);
}
function _pop() {
  _pop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(message, connectType, forceLogin, opts) {
    var onClose, onMessage, onReady, onResponse, _yield$renderPop, popup, unmount, internal, close, send;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          send = function _send(msg) {
            try {
              popup == null ? void 0 : popup.postMessage(JSON.parse(JSON.stringify(msg || {})), '*');
            } catch (error) {
              console.error('Popup Send Error', msg, error);
            }
          };
          close = function _close() {
            try {
              window.removeEventListener('message', internal);
              unmount();
              onClose();
            } catch (error) {
              console.error('Popup Close Error', error);
            }
          };
          internal = function _internal(e) {
            try {
              if (typeof e.data !== 'object') return;
              var data = e.data;
              if (!data || !data.type) return;
              if (e.data.type === 'UP_CLOSE') close();
              if (data.type === 'UP_READY') onReady(e, {
                send: send,
                close: close
              });
              if (data.type === 'UP_RESPONSE') onResponse(e, {
                send: send,
                close: close
              });
              if (data.type === 'UP_EVENT') onMessage(e, {
                send: send,
                close: close
              });
            } catch (error) {
              console.error('Popup Callback Error', error);
              close();
            }
          };
          if (!(message == null)) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", {
            send: noop,
            close: noop
          });
        case 5:
          onClose = (opts == null ? void 0 : opts.onClose) || noop;
          onMessage = (opts == null ? void 0 : opts.onMessage) || noop;
          onReady = (opts == null ? void 0 : opts.onReady) || noop;
          onResponse = (opts == null ? void 0 : opts.onResponse) || noop;
          window.addEventListener('message', internal);
          _context.next = 12;
          return renderPop(serviceEndPoint(message.type, connectType, forceLogin), onResponse, message.appSetting);
        case 12:
          _yield$renderPop = _context.sent;
          popup = _yield$renderPop.popup;
          unmount = _yield$renderPop.unmount;
          return _context.abrupt("return", {
            send: send,
            close: close
          });
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _pop.apply(this, arguments);
}

var UPA_SESSION_KEY = 'UP-A';
function execPop(message, connectType, forceLogin, listener) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return pop(message, connectType, forceLogin, {
              onReady: function onReady(_, callbacks) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var send;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        send = callbacks.send;
                        _context.prev = 1;
                        send(message);
                        _context.next = 8;
                        break;
                      case 5:
                        _context.prev = 5;
                        _context.t0 = _context["catch"](1);
                        throw _context.t0;
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[1, 5]]);
                }))();
              },
              onResponse: function onResponse(e, callbacks) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  var close, up_message, resp;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        close = callbacks.close;
                        _context2.prev = 1;
                        if (!(typeof e.data !== 'object')) {
                          _context2.next = 4;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 4:
                        up_message = e.data;
                        resp = JSON.parse(up_message.payload);
                        _context2.t0 = resp.type;
                        _context2.next = _context2.t0 === 'APPROVE' ? 9 : _context2.t0 === 'DECLINE' ? 12 : 27;
                        break;
                      case 9:
                        resolve(resp.data);
                        close();
                        return _context2.abrupt("break", 30);
                      case 12:
                        if (!(resp.data === 'expired')) {
                          _context2.next = 24;
                          break;
                        }
                        if (!(message.type === 'UP_LOGIN')) {
                          _context2.next = 15;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 15:
                        if (!(message.type === 'UP_LOGOUT')) {
                          _context2.next = 19;
                          break;
                        }
                        resolve(resp.data);
                        close();
                        return _context2.abrupt("return");
                      case 19:
                        if (!(message.type === 'UP_TRANSACTION' || message.type === 'UP_SIGN_MESSAGE')) {
                          _context2.next = 24;
                          break;
                        }
                        // clear session storage
                        disconnect(false);
                        reject("can not authorize without login");
                        close();
                        return _context2.abrupt("break", 30);
                      case 24:
                        reject("Declined: " + (resp.data || 'No reason supplied'));
                        close();
                        return _context2.abrupt("break", 30);
                      case 27:
                        reject("Declined: No reason supplied");
                        close();
                        return _context2.abrupt("break", 30);
                      case 30:
                        _context2.next = 35;
                        break;
                      case 32:
                        _context2.prev = 32;
                        _context2.t1 = _context2["catch"](1);
                        throw _context2.t1;
                      case 35:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 32]]);
                }))();
              },
              onMessage: function onMessage(e, _callbacks) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var up_message, upEvent;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (listener) {
                          _context3.next = 2;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 2:
                        _context3.prev = 2;
                        if (!(typeof e.data !== 'object')) {
                          _context3.next = 5;
                          break;
                        }
                        return _context3.abrupt("return");
                      case 5:
                        up_message = e.data;
                        upEvent = JSON.parse(up_message.payload);
                        listener(upEvent);
                        _context3.next = 13;
                        break;
                      case 10:
                        _context3.prev = 10;
                        _context3.t0 = _context3["catch"](2);
                        throw _context3.t0;
                      case 13:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3, null, [[2, 10]]);
                }))();
              },
              onClose: function onClose() {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        reject("Declined: Externally Halted");
                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }))();
              }
            }
            // type
            );
          case 2:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

var authorize = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(message, config) {
    var sessionAccount, account, msg, resp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sessionAccount = useStorage(config.storageType).get(UPA_SESSION_KEY);
          account = sessionAccount && JSON.parse(sessionAccount);
          if (!(!account || !message.from || account.address.toLowerCase() !== message.from.toLowerCase())) {
            _context.next = 4;
            break;
          }
          throw new Error('can not authorize without login');
        case 4:
          msg = new UPMessage('UP_SIGN_MESSAGE', JSON.stringify(message), config == null ? void 0 : config.appSettings);
          _context.prev = 5;
          _context.next = 8;
          return execPop(msg);
        case 8:
          resp = _context.sent;
          return _context.abrupt("return", resp);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](5);
          throw new Error(_context.t0);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 12]]);
  }));
  return function authorize(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var sendTransaction = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tx, config) {
    var sessionAccount, account, msg, resp;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sessionAccount = useStorage(config.storageType).get(UPA_SESSION_KEY);
          account = sessionAccount && JSON.parse(sessionAccount);
          if (!(!account || !tx.from || account.address.toLowerCase() !== tx.from.toLowerCase())) {
            _context.next = 4;
            break;
          }
          throw new Error('can not authorize without login');
        case 4:
          msg = new UPMessage('UP_TRANSACTION', JSON.stringify(tx), config.appSettings);
          _context.prev = 5;
          _context.next = 8;
          return execPop(msg);
        case 8:
          resp = _context.sent;
          return _context.abrupt("return", resp);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](5);
          throw new Error(_context.t0);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 12]]);
  }));
  return function sendTransaction(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
var EIP1271_SELECTOR = '0x1626ba7e';
var unipassMessagePrefix = '\x18UniPass Signed Message:\n';
function unipassHashMessage(message) {
  if (typeof message === 'string') {
    message = toUtf8Bytes(message);
  }
  return keccak256(concat([toUtf8Bytes(unipassMessagePrefix), toUtf8Bytes(String(message.length)), message]));
}
var UniPassPopupSDK = /*#__PURE__*/function () {
  function UniPassPopupSDK(options) {
    this.initConfig(options);
  }
  /**
   * init configurations
   * @param options
   */
  var _proto = UniPassPopupSDK.prototype;
  _proto.initConfig = function initConfig(options) {
    this._config = {
      env: 'prod',
      nodeRPC: '',
      chainType: 'polygon',
      storageType: 'sessionStorage'
    };
    this._config.env = options.env || 'prod';
    this._config.chainType = options.chainType || 'polygon';
    var defaultConfig = getDefaultConfigOption(this._config.env, this._config.chainType);
    this._config.nodeRPC = options.nodeRPC || defaultConfig.nodeRPC;
    this._config.appSettings = getAppSettings(this._config.chainType, options.appSettings);
    this._provider = new JsonRpcProvider(this._config.nodeRPC);
    this._auth_provider = new JsonRpcProvider(getAuthProviderUrl(this._config.env));
    var walletUrl = options.walletUrl || defaultConfig.walletUrl;
    if (walletUrl) {
      config$1(walletUrl);
    }
    this._config.storageType = options.storageType || 'sessionStorage';
  };
  _proto.updateConfig = function updateConfig(options) {
    if (!this._config) {
      return;
    }
    if (options.chainType) {
      this._config.chainType = options.chainType;
    }
    if (options.nodeRPC) {
      this._config.nodeRPC = options.nodeRPC;
      this._provider = new JsonRpcProvider(this._config.nodeRPC);
    }
    if (options.appSettings) {
      this._config.appSettings = options.appSettings;
    }
  }
  /**
   * initialize with user's username and email
   */;
  _proto.login =
  /*#__PURE__*/
  function () {
    var _login = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return connect(this._config, options);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function login(_x) {
      return _login.apply(this, arguments);
    }
    return login;
  }();
  _proto.getAccount = function getAccount() {
    var account = getLocalAccount(this._config.storageType);
    return account;
  };
  _proto.logout = /*#__PURE__*/function () {
    var _logout = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(deep) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (deep === void 0) {
              deep = false;
            }
            _context2.next = 3;
            return disconnect(deep);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function logout(_x2) {
      return _logout.apply(this, arguments);
    }
    return logout;
  }();
  _proto.getProvider = function getProvider() {
    return this._provider;
  };
  _proto.getAuthProvider = function getAuthProvider() {
    return this._auth_provider;
  };
  _proto.isLogin = function isLogin() {
    return !!this.getAccount();
  };
  _proto.assertLogin = function assertLogin() {
    if (!this.isLogin()) {
      throw new Error("user is not login");
    }
  }
  /**
   * get UniPass user's asset contract address on rangers.
   *
   * @returns asset contract address
   */;
  _proto.getAddress = function getAddress() {
    this.assertLogin();
    return this.getAccount().address;
  }
  /**
   * call user's asset contract to send eth to a specified account
   *
   * @param to the receiver's address
   * @param amount the send amount, unit: wei
   * @returns the send transaction hash
   */;
  _proto.sendTransaction =
  /*#__PURE__*/
  function () {
    var _sendTransaction2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_transaction) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            this.assertLogin();
            _context3.next = 3;
            return sendTransaction(_transaction, this._config);
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function sendTransaction$1(_x3) {
      return _sendTransaction2.apply(this, arguments);
    }
    return sendTransaction$1;
  }()
  /**
   * @param message - message will been signed
   * @param options.isEIP191Prefix - if true, sign with EIP191 prefix
   * @param options.onAuthChain - if true, sign on auth chain(polygon)
   * @returns The '0x'-prefixed hex encoded signature.
   */
  ;
  _proto.signMessage =
  /*#__PURE__*/
  function () {
    var _signMessage = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(message, options) {
      var _ref, _ref$isEIP191Prefix, isEIP191Prefix, _ref$onAuthChain, onAuthChain;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            this.assertLogin();
            _ref = options || {}, _ref$isEIP191Prefix = _ref.isEIP191Prefix, isEIP191Prefix = _ref$isEIP191Prefix === void 0 ? false : _ref$isEIP191Prefix, _ref$onAuthChain = _ref.onAuthChain, onAuthChain = _ref$onAuthChain === void 0 ? true : _ref$onAuthChain;
            if (typeof message === 'string') {
              message = toUtf8Bytes(message);
            }
            _context4.next = 5;
            return authorize(new UPAuthMessage(this.getAddress(), hexlify(message), 'V1', isEIP191Prefix, onAuthChain), this._config);
          case 5:
            return _context4.abrupt("return", _context4.sent);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function signMessage(_x4, _x5) {
      return _signMessage.apply(this, arguments);
    }
    return signMessage;
  }()
  /**
   * @deprecated a new version signature verification method `verifyMessageSignature` is already provided by the @unipasswallet/popup-utils package
   *
   * @param msg - the message to be signed
   * @param sig - the signature response returned by UniPass
   * @param account - the account who signed the message
   * @returns boolean true: pass verification, false: failed verification
   */
  ;
  _proto.isValidSignature =
  /*#__PURE__*/
  function () {
    var _isValidSignature = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_msg, _sig, _account) {
      var contract, code;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!_account) {
              this.assertLogin();
              _account = this.getAddress();
            }
            contract = new Contract(_account, [{
              inputs: [{
                internalType: 'bytes32',
                name: '_hash',
                type: 'bytes32'
              }, {
                internalType: 'bytes',
                name: '_signature',
                type: 'bytes'
              }],
              name: 'isValidSignature',
              outputs: [{
                internalType: 'bytes4',
                name: 'magicValue',
                type: 'bytes4'
              }],
              stateMutability: 'view',
              type: 'function'
            }], this._auth_provider);
            _context5.next = 4;
            return contract.isValidSignature(unipassHashMessage(_msg), _sig);
          case 4:
            code = _context5.sent;
            return _context5.abrupt("return", code === EIP1271_SELECTOR);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function isValidSignature(_x6, _x7, _x8) {
      return _isValidSignature.apply(this, arguments);
    }
    return isValidSignature;
  }()
  /**
   *
   * * V4 is based on [EIP-712](https://eips.ethereum.org/EIPS/eip-712), and includes full support of
   * arrays and recursive data structures.
   *
   * @param data - The typed data to sign.
   * @param options.onAuthChain - if true, sign on auth chain(polygon)
   * @returns The '0x'-prefixed hex encoded signature.
   */
  ;
  _proto.signTypedData =
  /*#__PURE__*/
  function () {
    var _signTypedData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(data, options) {
      var _ref2, _ref2$onAuthChain, onAuthChain;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            this.assertLogin();
            if (!(data == null)) {
              _context6.next = 3;
              break;
            }
            throw new Error('Missing data parameter');
          case 3:
            _ref2 = options || {}, _ref2$onAuthChain = _ref2.onAuthChain, onAuthChain = _ref2$onAuthChain === void 0 ? true : _ref2$onAuthChain;
            _context6.next = 6;
            return authorize(new UPAuthMessage(this.getAddress(), JSON.stringify(data), 'V4', false, onAuthChain), this._config);
          case 6:
            return _context6.abrupt("return", _context6.sent);
          case 7:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function signTypedData(_x9, _x10) {
      return _signTypedData.apply(this, arguments);
    }
    return signTypedData;
  }()
  /**
   * @deprecated a new version signature verification method `verifyTypedDataSignature` is already provided by the @unipasswallet/popup-utils package
   *
   * Valid the address of the account that created the given EIP-712
   * signature. The version provided must match the version used to
   * create the signature.
   *
   * @param options._data - The typed data that was signed.
   * @param options._sig - The '0x-prefixed hex encoded message signature.
   * @param options._account - The address of user.
   * @returns boolean true: pass verification, false: failed verification.
   */
  ;
  _proto.isValidTypedSignature =
  /*#__PURE__*/
  function () {
    var _isValidTypedSignature = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(_data, _account, _sig) {
      var contract, messageHash, code;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!(_data == null)) {
              _context7.next = 2;
              break;
            }
            throw new Error('Missing data parameter');
          case 2:
            if (!_account) {
              this.assertLogin();
              _account = this.getAddress();
            }
            contract = new Contract(_account, [{
              inputs: [{
                internalType: 'bytes32',
                name: '_hash',
                type: 'bytes32'
              }, {
                internalType: 'bytes',
                name: '_signature',
                type: 'bytes'
              }],
              name: 'isValidSignature',
              outputs: [{
                internalType: 'bytes4',
                name: 'magicValue',
                type: 'bytes4'
              }],
              stateMutability: 'view',
              type: 'function'
            }], this._auth_provider);
            messageHash = encodeTypedDataDigest(_data);
            _context7.next = 7;
            return contract.isValidSignature(messageHash, _sig);
          case 7:
            code = _context7.sent;
            return _context7.abrupt("return", code === EIP1271_SELECTOR);
          case 9:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function isValidTypedSignature(_x11, _x12, _x13) {
      return _isValidTypedSignature.apply(this, arguments);
    }
    return isValidTypedSignature;
  }();
  return UniPassPopupSDK;
}();

export { EIP1271_SELECTOR, UniPassPopupSDK, ZERO_ADDRESS, getAppSettings, getAuthProviderUrl, getConfig, getDefaultConfigOption, unipassHashMessage, unipassMessagePrefix };
//# sourceMappingURL=popup-sdk.esm.js.map
